import "./datatable.scss";
import "../../style/style.css";
import { DataGrid } from "@mui/x-data-grid";
import { userColumns, userRows, fileColumns } from "../../datatablesource";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  getDoc,
  deleteDoc,
  doc,
  onSnapshot,
  query
} from "firebase/firestore";
import { UserAuth } from '../../context/AuthContext'
import { getMetadata, ref, listAll, getDownloadURL, deleteObject } from "firebase/storage";
import { db, storage, DB, database, App, dataB } from "../../firebase";
import { getFirestore } from "firebase/firestore";
import { getApp } from "firebase/app"
import axios from "axios";
import { isVideo, isAudio, isVoicemail, isDoc, isImage } from "../../filesType";
import { downloadFolderAsZip } from '../../DownloadAll'


//const apiKey = "api_production_e885c7ca6837dd6b55968ffac8834a10e3454c2af454080932669d64c72fe436.689a9cdb134bd94e6f053737.689bd8dc134bd94e6f05500a";


const Datatable = ({ dir }) => {
  const [data, setData] = useState([]);
  const { user } = UserAuth();
  const [isActive, setIsActive] = useState(false)
  const [spin, setSpin] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      let list = [];
      try {
        // const docRef = doc(db, "users", "qmWnk9Nd88MoOIOzTrv6M9RRB093");
        // const docSnap = await getDoc(docRef);

        //const listRef = ref(storage, 'qmWnk9Nd88MoOIOzTrv6M9RRB093');
        //const list = await listAll(listRef);

        const listRef = await ref(storage, `${user.uid}/${dir}`);
        const listResult = await listAll(listRef);
        for (const item of listResult.items) {
          const itemMedataData = await getMetadata(item);
          const itemURL = await getDownloadURL(item);
          //console.log('push: ', {id: item.name, ...itemMedataData, url:itemURL})
          list.push({ id: item.name, url: itemURL, ...itemMedataData });
          //console.log(itemMedataData)
        };

        //list.push({ id: docSnap.id, ...docSnap.data() });
        // const querySnapshot = await getDoc(collection(db, "users"));
        // querySnapshot.forEach((doc) => {
        //   list.push({ id: doc.id, ...doc.data() });
        // });
        setData(list);
        //console.log('my list ',list);

        //console.log('** TEST **')


        //console.log(dbRef)

        // const userDoc = db
        //   .collection('users')
        //   .doc('qmWnk9Nd88MoOIOzTrv6M9RRB093')
        //   .get();

        //   console.log(userDoc)

        // DONE!!
        //         const docRef = doc(DB, "users", "qmWnk9Nd88MoOIOzTrv6M9RRB093");
        // const docSnap = await getDoc(docRef);

        // if (docSnap.exists()) {
        //   console.log("Document data:", docSnap.data());
        // } else {
        //   // docSnap.data() will be undefined in this case
        //   console.log("No such document!");
        //}


        // querySnapshot.forEach((doc) => {
        //   // doc.data() is never undefined for query doc snapshots
        //   console.log(doc.id, " => ", doc.data());
        // });

        //  const docRef = doc(db, "users", "qmWnk9Nd88MoOIOzTrv6M9RRB093");
        //  const docSnap = await getDoc(docRef);
        //  console.log('doc: ', docSnap)

        //         const docRef = doc(db, "users", "SF");
        // const docSnap = await getDoc(docRef);

        // if (docSnap.exists()) {
        //   console.log("Document data:", docSnap.data());
        // } else {
        //   // doc.data() will be undefined in this case
        //   console.log("No such document!");
        // }

        // const q = query(collection(db, "users/qmWnk9Nd88MoOIOzTrv6M9RRB093"))
        //   const unsub = onSnapshot(q, (querySnapshot) => {
        //     console.log("Data", querySnapshot.docs.map(d => doc.data()));
        //   });

        // await getDocs(collection(db, "users"))
        // .then((querySnapshot)=>{               
        //     const newData = querySnapshot.docs
        //         .map((doc) => ({...doc.data(), id:doc.id }));
        //     //setTodos(newData);                
        //     console.log('new data: ', newData);
        // })

        //const cityRef = db.collection('cities').doc('SF');
        // const cityRef =  await collection(db,"users")
        // const docRef = await getDocs(cityRef,'qmWnk9Nd88MoOIOzTrv6M9RRB093')
        // const doc = docRef.docs;
        // if (!doc.exists) {
        //   console.log('No such document!');
        // } else {
        //   console.log('Document data:', doc.data());
        // }



        // const collectionRef = doc(DB, 'users', 'qmWnk9Nd88MoOIOzTrv6M9RRB093'); 

        // await getDoc(collectionRef)
        // .then((todo) => {
        //   console.log('--> ',todo)
        //   })
        // .catch((err) => {
        //     console.log('error ', err);
        //   })



      } catch (err) {
        //console.log('error listing: ', err);
      }
    };

    fetchData();



    // LISTEN (REALTIME)
    // const unsub = onSnapshot(
    //   collection(db, "users"),
    //   (snapShot) => {
    //     let list = [];
    //     snapShot.docs.forEach((doc) => {
    //       list.push({ id: doc.id, ...doc.data() });
    //     });
    //     setData(list);
    //   },
    //   (error) => {
    //     console.log(error);
    //   }
    // );

    // return () => {
    //   unsub();
    // };
  }, [dir, user]);

  function getDateFromUnixTime(timestamp) {
    // Convert string input to number just in case
    const num = Number(timestamp);

    // If the number is small (less than 100 billion), it's in seconds.
    // Multiplying it by 1000 converts it to milliseconds.
    const milliseconds = num < 100000000000 ? num * 1000 : num;

    return new Date(milliseconds);
  }

  function formatDate(d) {
    const D = getDateFromUnixTime(d)
    return D.toLocaleString(undefined, { timeZone: 'UTC' })
  }

  const Convert = async (url, name) => {
    setSpin(name)
    axios.post("/api/convert",
      {
        tasks: {
          myImport1: {
            operation: "import/url",
            url: url,
            filename: name,
          },
          myConvert1: {
            operation: "convert",
            input: "myImport1",
            output_format: "mp3",
          },
          myExport1: {
            operation: "export/url",
            input: "myConvert1",
          },
        },
      },
    )
      .then((response) => {
        setTimeout(() => {
          axios.get(`/api/task-status?taskId=${response.data.tasks[2].id}`,
            {

            })
            .then((taskResponse) => {
              setSpin('')
              let w = window.open(taskResponse.data.result.url, '_blank');
              if (!w) {
                alert('It looks like your browser is blocking the download. To get your file, please temporarily allow pop-ups for this website in your browser settings.');
              }
            })
          //.catch(e => console.log('error task: ', e))
        }, 7000);

      })
    //.catch(e => console.log('error job: ', e))
  }

  const convertUrlToBase64 = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Failed to convert image to Base64:", error);
      return null;
    }
  };

  // Call the Firebase REST API
  const processImage = async (url) => {
    try {
      const base64Image = await convertUrlToBase64(url);
      if (base64Image == null) {
        alert('Image cannot be processed')
        return;
      }
      const response = await fetch('/api/imageAnalyzer', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ image_base64: base64Image }),
      });

      const json = await response.json();

      if (response.ok && json.success && json.data.messages.length > 0) {
        //console.log(json.data.message , json.data.contact_header)
        const from = json.data.contact_header || 'noname';
        const fileContent = json.data.messages.map(item => {
          //const formattedDate = new Date(item.timestamp).toLocaleString();
          return `From: ${item.sender}\nTo: ${item.receiver}\nMessage: ${item.text}\nDate: ${formatDate(item.timestamp)}`;
        }).join('\n\n\n'); // '\n\n\n' creates two blank lines of separation between objects
        const blob = new Blob([`SMS conversation: ${from}\nMessages:\n\n${fileContent}`], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = from + '.txt';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } else {
        alert('Processing Error', json.error || 'Failed to analyze screenshot.');
      }
    } catch (error) {
      console.log('Network Error', 'Could not connect to the Firebase Cloud Function.', error);
    } finally {

    }

  };

  const handleDelete = async (path) => {
    try {
      const listRef = await ref(storage, path);
      deleteObject(listRef).then(() => {
        // File deleted successfully
        window.location.reload();
      }).catch((error) => {
        // Uh-oh, an error occurred!
        //console.log(error);
      });

    } catch (err) {
      //console.log(err);
    }
  };

  const handleCellClick = (param, event) => {
    event.stopPropagation();
  };

  const handleRowClick = (param, event) => {
    event.stopPropagation();
  };

  // const isVideo = (prm) => {
  //   const ext = prm.substring(prm.lastIndexOf('.') + 1, prm.length);
  //   const videoArr = ['m4a', 'mov', 'vid'];
  //   if (videoArr.includes(ext)) {
  //     return true;
  //   }
  //   return false;
  // }

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 400,
      renderCell: (params) => {
        const ext = params.id.substring(params.id.lastIndexOf('.') + 1, params.id.length);
        const isMedia = isVideo(ext) || isAudio(ext) || isVoicemail(ext)
        return (
          <div className="cellAction" >
            {spin == params.id ?
              <div class="spinner-3"></div>
              :
              <select onChange={async e => {
                switch (e.target.value) {
                  case '1':
                    //window.open(params.row.url, "_blank", "noopener,noreferrer");
                    const win = window.open('img');
                    win.document.write('<head><title>View</title></head>');
                    win.document.write('<img src="' + params.row.url + '">');
                    break;
                  case '2':
                    window.open(params.row.url, "_blank", "noopener,noreferrer");
                    break;
                  case '3':
                    const response = await fetch(params.row.url);
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = params.id;
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    link.remove();
                    break;
                  case '4':
                    Convert(params.row.url, params.id);
                    break;
                  case '5':
                    if (window.confirm('CAUTION: Any files deleted from this cloud website will also be permanently deleted from your device. If you want to save the file, please download before deleting. Are you sure you want to continue?')) {
                      handleDelete(`${user.uid}/${dir}/${params.id}`);
                    }
                    break;
                  case '6':
                    if (window.confirm('Image analyzer will start processing the selected image (it may take up to 30 seconds), the result will be ready for download. Do you want to continue?')) {
                      processImage(params.row.url);
                    }
                    break;
                  default:
                    break;
                }
              }}>
                <option value="0">SELECT</option>
                {isDoc(ext) ? null :
                  <option value={isMedia ? "2" : "1"}>{isMedia ? 'PLAY' : 'VIEW'}</option>
                }

                <option value="3">DOWNLOAD</option>

                {isVoicemail(ext) ?
                  <option value="4">DOWNLOAD AS MP3</option>
                  : null
                }
                {isImage(ext) && dir == "sms" ?
                  <option value="6">CONVERT TO TEXT</option>
                  : null
                }
                <option value="5">DELETE</option>
              </select>
            }

            {/* <div className="navigation">
              <div className={`menuToggle ${isActive ? 'active' : ''}`} onClick={()=>{setIsActive(!isActive)}}></div>
              <div className="menu">
                <ul>
                  <li ><a href="#">UNO</a></li>
                  <li ><a href="#">DOS</a></li>
                  <li ><a href="#">TRES</a></li>
                </ul>
              </div>
            </div> */}
            {/* <Link to={params.row.url} style={{ textDecoration: "none" }}>
              <div className="viewButton">View</div>
            </Link> */}
            {/* <div
              className="deleteButton"
              onClick={() => {console.log('del', params.id)}}
            >
              Delete
            </div> */}

            {/* <a href={params.row.url} style={{ textDecoration: "none" }} target="_blank">
              <div className="viewButton">{isMedia ? 'Play' : 'View'}</div>
            </a>
            <a href="" style={{ textDecoration: "none" }} target="_blank" download={params.id} onClick={(e) => {
              e.preventDefault();

              const link = document.createElement('a');
              link.href = params.row.screenshot;
              link.download = params.id;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}>
              <div className="viewButton">Download</div>
            </a>
            {isVoicemail(ext) && (
              <div
                className="viewButton"
                style={{ textDecoration: "none" }}
                onClick={() => {
                  //console.log('will transform', params);
                  Convert(params.row.url, params.id);
                }}
              >
                {spin == params.id ? <div class="spinner-3"></div> : 'Convert'}
              </div>
            )} */}


          </div>
        );
      },
    },
  ];
  return (
    <div className="datatable">
      <div className="datatableTitle">
        {dir == 'images' ? 'Photos' : dir}
        {/* <Link to="/users/new" className="link">
          Add New
        </Link> */}
        <div>
          <button type="button"
            onClick={() => {
              //console.log("DAta: ", data) 
              alert('Download will be processed shortly, please wait...');
              downloadFolderAsZip(data, dir);
            }}
            className="downloadButton">
            Download all {dir}
          </button>
        </div>
      </div>
      <DataGrid
        className="datagrid"
        rows={data}
        columns={fileColumns.concat(actionColumn)}
        //pageSize={5}
        //rowsPerPageOptions={[5]}
        //checkboxSelection
        onCellClick={handleCellClick}
        onRowClick={handleRowClick}
        initialState={{
          sorting: {
            sortModel: [{ field: 'updated', sort: 'desc' }],
          },
        }}

      />

    </div>
  );
};

export default Datatable;